(function ($) {
const readMoreEls = document.querySelectorAll('.read-more-js');
if (readMoreEls.length > 0) {
    readMoreEls.forEach(el => {
        const minHeight = (el.getAttribute('data-rm-min-height')) ? el.getAttribute('data-rm-min-height') : '100px';
        const maxHeight = (el.getAttribute('data-rm-max-height')) ? el.getAttribute('data-rm-max-height') : '100%';
        const moreText = (el.getAttribute('data-rm-more-text')) ? el.getAttribute('data-rm-more-text') : 'Show more +';
        const lessText = (el.getAttribute('data-rm-less-text')) ? el.getAttribute('data-rm-less-text') : 'Show less -';
        const wrapper = document.createElement('div');
        wrapper.classList.add('rm-wrap');
        wrapper.style.height = minHeight;
        wrapper.style.maxHeight = maxHeight;
        while (el.firstChild) {
            wrapper.appendChild(el.firstChild);
        }
        el.appendChild(wrapper);
        createButtons(el, moreText, lessText);
        addListeners(el, minHeight);
    });

    function createButtons(el, moreText, lessText) {
        const moreButton = document.createElement('a');
        moreButton.classList.add('rm-btn', 'more-btn');
        moreButton.innerText = moreText;
        el.append(moreButton);

        const lessButton = document.createElement('a');
        lessButton.classList.add('rm-btn', 'less-btn');
        lessButton.innerText = lessText;
        el.append(lessButton);
    }

    function addListeners(el, minHeight) {
        el.querySelector('.more-btn').addEventListener('click', function (e) {
            e.preventDefault();
            el.classList.add('active');
            el.querySelector('.rm-wrap').style.height = 'auto';
        });
        el.querySelector('.less-btn').addEventListener('click', function (e) {
            e.preventDefault();
            el.classList.remove('active');
            el.querySelector('.rm-wrap').style.height = minHeight;
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }
}
})(jQuery);